export var EApiDatafanStreamReportStatus;
(function (EApiDatafanStreamReportStatus) {
    EApiDatafanStreamReportStatus[EApiDatafanStreamReportStatus["ERROR"] = 0] = "ERROR";
    EApiDatafanStreamReportStatus[EApiDatafanStreamReportStatus["REPEAT"] = 1] = "REPEAT";
    EApiDatafanStreamReportStatus[EApiDatafanStreamReportStatus["SUCCESS"] = 2] = "SUCCESS";
    EApiDatafanStreamReportStatus[EApiDatafanStreamReportStatus["LOCK"] = 3] = "LOCK";
    EApiDatafanStreamReportStatus[EApiDatafanStreamReportStatus["FORCE_REPEAT"] = 4] = "FORCE_REPEAT";
})(EApiDatafanStreamReportStatus || (EApiDatafanStreamReportStatus = {}));
export var EApiDatafanStreamStatus;
(function (EApiDatafanStreamStatus) {
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["DATA_COLLECTION"] = 0] = "DATA_COLLECTION";
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["IS_COMPLETED"] = 1] = "IS_COMPLETED";
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["DELETED"] = 2] = "DELETED";
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["ARCHIVED"] = 3] = "ARCHIVED";
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["CREDENTIAL_LOST"] = 4] = "CREDENTIAL_LOST";
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["CREDENTIAL_NOT_PERMISSION"] = 5] = "CREDENTIAL_NOT_PERMISSION";
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["CREDENTIAL_NOT_ACCOUNT_PERMISSION"] = 6] = "CREDENTIAL_NOT_ACCOUNT_PERMISSION";
    EApiDatafanStreamStatus[EApiDatafanStreamStatus["CREDENTIAL_LOST_SHARED"] = 7] = "CREDENTIAL_LOST_SHARED";
})(EApiDatafanStreamStatus || (EApiDatafanStreamStatus = {}));
export var EApiDatafanStreamSubType;
(function (EApiDatafanStreamSubType) {
    EApiDatafanStreamSubType["ADS"] = "ADS";
    EApiDatafanStreamSubType["COMMUNITY"] = "COMMUNITY";
    EApiDatafanStreamSubType["POST"] = "POST";
})(EApiDatafanStreamSubType || (EApiDatafanStreamSubType = {}));
//# sourceMappingURL=stream.js.map